import axios from "axios";

const api = axios.create({
  baseURL: "https://countriesnow.space/api/v0.1",
  headers: {
    "Content-Type": "application/json",
  },
});

export const getAllCountries = async (): Promise<string[]> => {
  try {
    const res = await api.get("/countries/positions");
    return res.data.data.map((c: { name: string }) => c.name) || [];
  } catch (error) {
    console.error("Error fetching countries:", error);
    return [];
  }
};

export const getStatesByCountry = async (country: string): Promise<string[]> => {
  try {
    const res = await api.post("/countries/states", { country });
    return res.data.data?.states?.map((item: { name: string }) => item.name) || [];
  } catch (error) {
    console.error("Error fetching states:", error);
    return [];
  }
};

export const getCitiesByState = async (country: string, state: string): Promise<string[]> => {
  try {
    const res = await api.post("/countries/state/cities", { country, state });
    return res.data.data || [];
  } catch (error) {
    console.error("Error fetching cities:", error);
    return [];
  }
};
